<script>
// @ts-check

import BaseInnerNavigationView from '@/views/BaseInnerNavigationView.vue'
import * as _ from 'lodash-es'

export default {
  name: 'Reports',
  components: {
    BaseInnerNavigationView
  },
  computed: {
    routes() {
      return _.first(this.$route.matched)?.children ?? []
    }
  }
}
</script>

<template>
  <BaseInnerNavigationView :title="$t(`routes.reports`)" :routes />
</template>
